import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS = Symbol('admin.payment-system-details-pending-requests');
export const TRANSLATION_GROUP_ADMIN_PAYMENT_SYSTEM_REQUESTS_HISTORY = Symbol('admin.payment-system-details-requests-history');
export const TRANSLATION_GROUP_AFFILIATE_PAYMENT_SYSTEM_PROFILE = Symbol('affiliate.payment-system-details-profile');

export const ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS_ROUTE_NAME = Symbol('admin.payment-system-details-pending-requests');
export const ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS_LIST_ROUTE_NAME = Symbol('admin.payment-system-details-pending-requests.list');
export const ADMIN_PAYMENT_SYSTEM_DETAILS_PENDING_REQUESTS_LIST_VIEW_ROUTE_NAME = Symbol('admin.payment-system-details-pending-requests.list.view');

export const ADMIN_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY_ROUTE_NAME = Symbol('admin.payment-system-details-requests-history');
export const ADMIN_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY_LIST_ROUTE_NAME = Symbol('admin.payment-system-details-requests-history.list');
export const ADMIN_PAYMENT_SYSTEM_DETAILS_REQUESTS_HISTORY_LIST_VIEW_ROUTE_NAME = Symbol('admin.payment-system-details-requests-history.list.view');

export const ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_QUERY_KEY = 'admin.payment-system-details.list';
export const ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_API_URL = 'admin/payment_change_forms_:tableType/list';

export const ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_MUTATION_KEY = 'admin.payment-system-details.list.download';
export const ADMIN_PAYMENT_SYSTEM_DETAILS_LIST_DOWNLOAD_API_URL = 'admin/payment_change_forms_:tableType/download_list';

export const ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_MUTATION_KEY = 'admin.payment-system-details.review';
export const ADMIN_PAYMENT_SYSTEM_DETAILS_PREVIEW_API_URL = 'admin/payment_systems/:id/:actionType';

export const ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_MUTATION_KEY = 'admin.payment-system-details.mass-review';
export const ADMIN_PAYMENT_SYSTEM_DETAILS_MASS_REVIEW_API_URL = 'admin/payment_systems/:actionType';

export const ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_QUERY_KEY = 'admin.payment-system-details.show';
export const ADMIN_PAYMENT_SYSTEM_DETAILS_SHOW_API_URL = 'admin/payment_systems/:id';

export const ADMIN_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY = 'admin.payment-systems.change';
export const ADMIN_CREATE_PAYMENT_SYSTEM_API_URL = 'admin/payment_systems/:id/update_payment_method';

export const AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_API_URL = 'affiliate/payment_systems/current_payment_info';
export const AFFILIATE_PAYMENT_SYSTEM_DETAILS_INFO_QUERY_KEY = 'affiliate.payment-systems-details.info';

export const AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_API_URL = ':namespace/payment_systems/allowed';
export const AFFILIATE_ALLOWED_PAYMENT_SYSTEMS_QUERY_KEY = 'payment-systems.allowed';

export const AFFILIATE_CHANGE_PAYMENT_SYSTEM_MUTATION_KEY = 'affiliate.payment-systems.change';
export const AFFILIATE_CREATE_PAYMENT_SYSTEM_API_URL = 'affiliate/payment_systems/change_payment_method';
export const AFFILIATE_RESEND_PAYMENT_SYSTEM_API_URL = 'affiliate/payment_systems/:id/resend';

export const AFFILIATE_CANCEL_PAYMENT_SYSTEM_MUTATION_KEY = 'affiliate.payment-systems.cancel';
export const AFFILIATE_CANCEL_PAYMENT_SYSTEM_API_URL = 'affiliate/payment_systems/:id/cancel';

export const PAYMENT_SYSTEM_DETAILS_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_SHOW, PermissionsList.affiliate.PAYMENTSYSTEMS_SHOW),
  UPDATE: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_UPDATE, PermissionsList.affiliate.PAYMENTSYSTEMS_UPDATE),
  EDIT_PAYMENT_METHOD: new Permission(PermissionsList.admin.EDIT_PAYMENT_METHOD),
  CREATE: new Permission(undefined, PermissionsList.affiliate.PAYMENTSYSTEMS_CREATE),
  PENDING_LIST_SHOW: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_PENDING_LIST_SHOW),
  PENDING_DOWNLOAD_LIST: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_DOWNLOAD_PENDING_LIST),
  HISTORY_LIST_SHOW: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_HISTORY_LIST_SHOW),
  HISTORY_DOWNLOAD_LIST: new Permission(PermissionsList.admin.PAYMENTSYSTEMS_DOWNLOAD_HISTORY_LIST),
};

export const PAYMENT_SYSTEMS = [
  {
    name: 'Epayments',
    localizationShortCode: 'epayments.',
    icon: undefined,
    fields: {
      wallet: {},
    },
  },
  {
    name: 'Neteller',
    localizationShortCode: 'neteller.',
    icon: undefined,
    fields: {
      username: {},
      email: {},
    },
  },
  {
    name: 'Paypal',
    localizationShortCode: 'paypal.',
    icon: undefined,
    fields: {
      username: {},
      email: {},
    },
  },
  {
    name: 'Webmoney',
    localizationShortCode: 'webmoney.',
    icon: undefined,
    fields: {
      username: {},
      wallet: {},
    },
  },
  {
    name: 'Bank transfer',
    localizationShortCode: 'bank_transfer.',
    icon: '/bank-transfer.svg',
    fields: {
      country_code: { required: true },
      company_name: {},
      company_country: {},
      company_city: {},
      company_address: {},
      company_postal: {},
      bank_name: {},
      bank_country: {},
      bank_address: {},
      bank_city: {},
      iban: {},
      bic: {},
      account_holders_name: {},
      branch_code: {},
      routing_number: {},
    },
  },
  {
    name: 'Visa/Master card',
    localizationShortCode: 'bank_card.',
    icon: undefined,
    fields: {
      username: {},
      card_number: {},
      bank_name: {},
      country: {},
      city: {},
      address: {},
      iban: {},
      bic: {},
      swift: {},
    },
  },
  {
    name: 'Yandex.Money',
    localizationShortCode: 'yandex_money.',
    icon: undefined,
    fields: {
      wallet: {},
    },
  },
  {
    name: 'Qiwi',
    localizationShortCode: 'qiwi.',
    icon: undefined,
    fields: {
      phone_number: {},
    },
  },
  {
    name: 'Capitalist',
    localizationShortCode: 'capitalist.',
    icon: undefined,
    fields: {
      wallet: {},
    },
  },
  {
    name: 'USDT (erc20)',
    localizationShortCode: 'usdt_erc20.',
    icon: '/usdt-erc20.svg',
    fields: {
      wallet: {},
    },
  },
  {
    name: 'USDT (trc20)',
    localizationShortCode: 'usdt_trc20.',
    icon: '/usdt-trc20.svg',
    fields: {
      wallet: {},
    },
  },
  {
    name: 'Skrill',
    localizationShortCode: 'skrill.',
    icon: '/skrill.svg',
    fields: {
      username: {},
      email: {},
    },
  },
  {
    name: 'Player account',
    localizationShortCode: 'player_account.',
    icon: undefined,
    fields: {
      poker_nickname: {},
    },
  },
  {
    name: 'Bitcoin',
    localizationShortCode: 'bitcoin.',
    icon: undefined,
    fields: {
      wallet: {},
    },
  },
] as const;
